import React, { ReactNode } from "react";

export const About = ({
  title,
  subtitle,
  id,
}: {
  title: string;
  subtitle: string;
  id: string;
}) => {
  return (
    <div className={"section"}>
      <div className="sectiondiv orangebg" id={id}>
        <div className="content">
          <h1>{title}</h1>
          <p>Ben je op zoek naar een creatieve oplossing, ik help je verder. </p>
        </div>
      </div>
    </div>
  );
};
